import { getLogger } from '@hopdrive/sdk-core'
import { getDefaultGeoProviders } from '../../init'
import type { SuggestResult } from '../../geo/types/suggestion'

export interface SuggestAddressesParams {
  /** The text input to search for */
  input: string
  /** Session token for billing grouping */
  sessionToken?: string
  /** ISO 3166-1 alpha-2 region bias (e.g. 'US') */
  regionBias?: string
  /** Location bias to prefer results near a point */
  locationBias?: { latitude: number; longitude: number; radiusMeters?: number }
  /** Region codes to restrict results (e.g. ['us']) */
  includedRegionCodes?: string[]
  /** Place types to include (e.g. ['address', 'establishment']) */
  includedTypes?: string[]
  /** Language code for results */
  language?: string
}

export async function suggestAddresses(params: SuggestAddressesParams): Promise<SuggestResult> {
  const { suggestion } = getDefaultGeoProviders()
  const apiStart = Date.now()

  const result = await suggestion.suggest({
    input: params.input,
    sessionToken: params.sessionToken,
    regionBias: params.regionBias,
    locationBias: params.locationBias
      ? {
          center: {
            latitude: params.locationBias.latitude,
            longitude: params.locationBias.longitude,
          },
          radiusMeters: params.locationBias.radiusMeters,
        }
      : undefined,
    includedRegionCodes: params.includedRegionCodes,
    includedTypes: params.includedTypes,
    language: params.language,
  })

  getLogger().debug('suggestAddresses.complete', {
    input: params.input,
    predictionCount: result.predictions.length,
    apiMs: Date.now() - apiStart,
  })

  return result
}
